/**
 * @fileoverview GET handler for the "/companies/:company_id/sender_verification/eligibility" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdSenderVerificationEligibility } from "./constants";
import type { SenderVerificationEligibilityResult } from "./types";

export const getSenderVerificationEligibility = reactQueryFetcherAdapter(
  companiesCompanyIdSenderVerificationEligibility,
  (signal: AbortSignal, companyId: string): Promise<SenderVerificationEligibilityResult> => {
    return fetch(`/companies/${companyId}/sender_verification/eligibility`, "GET", {}, { signal });
  }
);
